import React, {useState, useEffect} from 'react';
import {useDispatch, useSelector} from 'react-redux'
import {CardDetailActions} from '../actions/CardDetailAction'
import {CardGridActions} from '../actions/CardGridAction'
import _ from 'lodash'




const ChecklistView = (props) => {

    const dispatch = useDispatch()
    const cardData = useSelector(state => state.cardGrid)
    const [currSet, setCurrSet] = useState('')
    const [mySets, setMySets] = useState([])
    const [loading, setLoading] = useState('ui  dimmer')
    const getChecklist = () => {
        if (currSet !== '') {
            dispatch(CardDetailActions.checklistInit())
            dispatch(CardDetailActions.getNeedList(currSet))
        }
    }
    const buildChecklistRow = (myItem) => {
        return (
            <tr key={myItem.cardNum} className={myItem.owned && myItem.owned === 'false' ? 'negative' : 'positive'}>
                <td><i className={myItem.owned && myItem.owned === 'false' ? 'icon close' : 'icon checkmark'}></i>
                {myItem.graded && myItem.graded !== 'RAW'? myItem.graded : ''} {myItem.condition ? myItem.condition : ''} {myItem.qualifier && myItem.qualifier !== 'None' ? myItem.qualifier : ''} 
                </td>
                <td data-label="Quantity">{myItem.quantity}</td>
                <td data-label="Card Number">{myItem.cardNum}</td>
                <td data-label="Player">{myItem.player}</td>
            </tr>
        )
    } 


    useEffect(() => {  
        if (cardData.checklistLoading) {
            setLoading('ui active dimmer')
        }
        else {
            setLoading('ui dimmer')
        }
      }, [cardData.checklistLoading]);


    useEffect(() => {  
        console.log('init Checklist View')
        if (cardData.cardGridData) {
            const uniqueSets = _.uniqBy(cardData.cardGridData, 'setName')
            setMySets(uniqueSets)
            console.log('My Sets: ' + mySets)
        }
        else {
            dispatch(CardGridActions.getUserGrid())        }
        // eslint-disable-next-line
      }, [cardData.cardGridData]);

    return (
    <div className="ui grid">
        <div className="four wide column">
            <br/>
            <div className="ui form">
                <div className="field">
                    <label>Select a Set</label>
                    <select onChange={e => setCurrSet(e.target.value)} value={currSet}>
                    <option value=''>Select a Set</option>    
                    {mySets.map(setItem =>
                        <option key={setItem.setName} value={setItem.setName}>{setItem.setName}</option>
                    )};
                    </select>
                </div>
                <button className="ui button" type="submit" onClick={getChecklist}>Get Checklist </button>
            </div>
        </div>
        <div className="eight wide column"></div>
            <div className={loading}>
                <div className="ui loader"></div>
            </div>
            <table className="ui sortable celled table">
                <thead>
                    <tr>
                    <th>Owned</th>
                    <th>Quantity</th>
                    <th>Card Number</th>
                    <th>Player</th>
                </tr></thead>
                <tbody>
                    {cardData.currChecklist ? cardData.currChecklist.map(myItem => buildChecklistRow(myItem)) : <tr><td></td></tr>}
                </tbody>
            </table>
        </div>
                
          
    )
    
}
export default ChecklistView